import { Metamodel } from 'app/model/base/model';
import { DataFlowDatasetSettings, DatasetFormatType } from './dataflow-dataset-settings';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format, IViolation } from 'shell-models-lib';
import { DataFlowExpression } from '../dataflowexpression';
import { KafkaDataset } from 'app/model/dataset/kafka.dataset';
import { isTruthy } from '../dataflow-expression-utilities';
import { DslConnectorConstants } from 'app/model/adapters/mappingArtifact/DslConnectorConstants';
import { BooleanDataFlowType, NumberDataFlowType, StringDataFlowType } from '../dataflow-datatype';


const supportedMessageFormat = new Set(['passthrough', 'json', 'avro', 'delimited']);

@Metamodel.model({
    name: adfModelTypeMap.kafka.dataflowSettings,
    validator: KafkaSettings.validateSettings
})
export class KafkaSettings extends DataFlowDatasetSettings {
    public static validateSettings(settings: KafkaSettings): IViolation[] {
        const violations: IViolation[] = [];

        if (!settings.subscribePattern?.expression && !settings.subscribe?.expression) {
            violations.push({
                context: settings.transform,
                message: () => format(stringResources.Streaming_Format_Validation, DslConnectorConstants.subscribe, DslConnectorConstants.subscribePattern)
            });
        }
        if (!settings.format) {
            violations.push({
                context: settings.transform,
                message: () => format(stringResources.RequiredTemplate, stringResources.DataFormat_Label)
            });
        }
        else if (!supportedMessageFormat.has(settings.format?.expression)) {
            violations.push({
                context: settings.transform,
                message: () => stringResources.Streaming_Format_Validation
            });
        }
        if (settings.format?.expression === 'avro' && !settings.payloadSchema?.expression) {
            violations.push({
                context: settings.transform,
                message: () => stringResources.Streaming_Avro_Schema_Validation
            });
        }
        if (settings.format?.expression !== 'passthrough' && !isTruthy(settings.isAutoInfer) && !settings.payloadSchema?.expression) {
            violations.push({
                context: settings.transform,
                message: () => format(stringResources.Streaming_PayloadSchema_Validation)
            });
        }
        if (isTruthy(settings.isAutoInfer) && (!settings.numSampleRecords?.expression || Number(settings.numSampleRecords.expression) < 1 || Number(settings.numSampleRecords.expression) > 2147483647)) {
            violations.push({
                context: settings.transform,
                message: () => stringResources.Streaming_NumSampleRecords_Validation
            });
        }
        return violations;
    }

    public getDatasetType(): string {
        return Metamodel.modelFor(KafkaDataset).name;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Kafka;
    }

    public getIconClass(): string {
        return 'i-100x100-kafka';
    }
    public rowDelimiter: string;
    @Metamodel.attribute({
    })
    public includeHeaders: DataFlowExpression;
    @Metamodel.attribute({
    })
    public bootstarpsServers: string;
    @Metamodel.attribute({
    })
    public format: DataFlowExpression;
    @Metamodel.attribute({
    })
    public subscribePattern?: DataFlowExpression;
    @Metamodel.attribute({
    })
    public payloadSchema: DataFlowExpression;
    @Metamodel.attribute({
    })
    public store: string;
    @Metamodel.attribute({
    })
    public password: string;
    @Metamodel.attribute({
    })
    public username: string;
    @Metamodel.attribute({
    })
    public saslMechanism: string;
    @Metamodel.attribute({
    })
    public subscribe: DataFlowExpression;
    @Metamodel.attribute({
    })
    public securityProtocol: string;
    @Metamodel.attribute({
    })
    public isSinkSchemaQuery?: boolean;

    @Metamodel.attribute({
    })
    public authenticationType: string;
    @Metamodel.attribute({
    })
    public numSampleRecords?: DataFlowExpression;
    @Metamodel.attribute({
    })
    public isAutoInfer?: DataFlowExpression;
    @Metamodel.attribute({
    })
    public instanceSelectionType?: DataFlowExpression;

    public initialize(subFormat: string): void {
        this.format = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, 'passthrough');
        this.instanceSelectionType = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, 'manual');
        this.subscribePattern = this.transform.createTemplatableExpression();
        this.subscribe = this.transform.createTemplatableExpression();
        this.payloadSchema = this.transform.createTemplatableExpression();
        this.includeHeaders = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');
        this.isAutoInfer = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'true');
        this.numSampleRecords = this.transform.createTemplatableExpression(NumberDataFlowType.TYPE, '10000');
    }
}
